import { BootConfig } from 'types/BootConfig';

/**
 * Boot-config resolution for the Virtual Library React SPA.
 *
 * When running inside Connexus, VirtualLibraryController serialises a
 * VirtualLibrarySpaInitialData object as JSON into the `data-custom-props`
 * attribute of the root element (id="root"). This file parses that JSON at
 * startup so the SPA knows the user's permissions and the API base URL.
 *
 * When running locally via Vite (no Connexus), the fallback mockBootConfig is
 * used. Set isMock: true to intercept /api/* calls with MirageJS mock data.
 * Set isMock: false and provide API_COOKIE in .env.local to proxy requests
 * through to a real Connexus environment — Vite forwards /api/* to the
 * configured target with the cookie injected server-side.
 */
const mockBootConfig: BootConfig = {
  isMock: false,
  authInfo: {
    featureFlags: {},
    idLoggedInWebuser: '1',
    permissions: {
      canManage: true,
      canUse: true,
      canCreateCategory: true,
      canModifyCategory: true,
      canDeleteCategory: true,
      canCreateResource: true,
      canModifyResource: true,
      canDeleteResource: true,
      canExcludeLocations: true,
    },
  },
  libraryApiBaseUrl: '/api',
  useNoLayout: false,
};

const rootDatasetProps =
  document.getElementById('root')?.dataset.customProps;

// Guard JSON.parse so a malformed data-custom-props attribute (e.g. injected
// by the host page with unexpected characters) does not crash the SPA during
// module initialisation. Falls back to mockBootConfig on any parse error.
const bootConfig: BootConfig = (() => {
  if (!rootDatasetProps) return mockBootConfig;
  try {
    return JSON.parse(rootDatasetProps) as BootConfig;
  } catch {
    return mockBootConfig;
  }
})();

export default bootConfig;
